import request from '@/axios/http'


// 进口数据列表查询
export function salesInCount (params) {
	return request({
		url: '/stage-api/pre/count/salesInCount',
		method: 'get',
		params
	})
}

// 出口数据列表查询
export function salesOutCount (params) {
	return request({
		url: '/stage-api/pre/count/salesOutCount',
		method: 'get',
		params
	})
}


// 获取缩水师审核列表详情
export function infoList (params) {
	return request({
		url: '/stage-api/cms/identity/infoList',
		method: 'get',
		params
	})
}

